import {graphqlQuery} from '../utils/graphqlQuery';
const gql = require('graphql-tag');

const OPERATION_NAME = 'graphql_get_price_summary';

const priceFromSummary = gql`
    query(
        $listingUrl: String!
        $unitId: String
        $arrivalDate: String
        $departureDate: String
        $adults: Int
        $children: Int
        $petIncluded: Boolean
    ) {
        listing(
            listingId: $listingUrl
            unitId: $unitId
            arrivalDate: $arrivalDate
            departureDate: $departureDate
            adults: $adults
            children: $children
            petIncluded: $petIncluded
        ) {
            priceSummary: priceSummary {
                priceTypeId
                edapEventJson
                formattedAmount
                roundedFormattedAmount
                pricePeriodDescription
                priceAccurate
            }
            priceSummarySecondary: priceSummary(summary: "displayPriceSecondary") {
                priceTypeId
                edapEventJson
                formattedAmount
                roundedFormattedAmount
                pricePeriodDescription
            }
            priceLabel: priceSummary(summary: "priceLabel") {
                priceTypeId
                pricePeriodDescription
            }
        }
    }
`;

async function priceSummaryGraphql(
    {
        unitId,
        arrivalDate,
        departureDate,
        listingUrl = '',
        adults,
        children = 0,
        petIncluded = false
    },
    locale = ''
) {
    return await graphqlQuery(
        OPERATION_NAME,
        priceFromSummary,
        {
            arrivalDate,
            departureDate,
            listingUrl,
            // unit ID parameter for listing is a string
            // it is optional parameter so check if exist first
            // https://github.homeawaycorp.com/GraphQL/graphql-traveler-property/blob/master/lib/types/Query.gql#L26-L28
            unitId: (unitId && unitId.toString()) || null,
            adults,
            children,
            petIncluded
        },
        locale
    );
}
export {priceSummaryGraphql, priceFromSummary, OPERATION_NAME};
